import resetUploadModel from './resetUploadModel';
import showForm from './showForm';

export default () => (dispatch) => {
    dispatch(resetUploadModel());
    dispatch(showForm(false));
};
